import { createReducer } from '@reduxjs/toolkit';

import getCompatibilityModelGroup, {
  setCompatibilityModelGroup
} from '../../thunks/Compatibility/getCompatibilityModelGroup';

const initialState = {
  loading: false,
  error: '',
  modelGroup: [],
};

const getCompatibilityModelGroupReducer = createReducer(initialState, {
  [getCompatibilityModelGroup.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCompatibilityModelGroup.fulfilled]: (state, { payload: { data, refresh } }) => ({
    ...state,
    loading: false,
    ...(refresh ? { modelGroup: [data] } : { modelGroup: [...state.modelGroup, ...data] }),
  }),
  [setCompatibilityModelGroup]: (state, { payload }) => ({
    ...state,
    modelGroup: payload
  }),
  [getCompatibilityModelGroup.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCompatibilityModelGroupReducer;
